import { lbAssays } from '@zero-dash/types';
import dayjs from 'dayjs';
import { ExportOptions } from '@/types/Export/ExportOptions.types';
import { IBiomaterialRow } from '@/types/PatientDashboard/TimelineView.types';

export const biomaterialsExportOptions: ExportOptions<IBiomaterialRow> = {
  name: {
    label: 'Biomaterial name',
    selected: true,
    key: 'name',
  },
  id: {
    label: 'Biomaterial ID',
    selected: true,
    key: 'id',
    transform: (value): string => String(value),
  },
  patientId: {
    label: 'Patient ID',
    selected: true,
    key: 'patientId',
  },
  subtype: {
    label: 'Subtype',
    selected: true,
    key: 'subtype',
  },
  collectionDate: {
    label: 'Sample collection date',
    selected: true,
    key: 'collectionDate',
    transform: (value): string => {
      const { date } = value as IBiomaterialRow['collectionDate'];
      return date ? dayjs(date).format('DD/MM/YYYY') : '';
    },
  },
  inventoryStatus: {
    label: 'Inventory Status',
    selected: true,
    key: 'inventoryStatus',
  },
  volume: {
    label: 'Volume',
    selected: true,
    key: 'volume',
  },
  containerType: {
    label: 'Container Type',
    selected: true,
    key: 'containerType',
  },
  assaysOrdered: {
    label: 'Assays ordered',
    selected: true,
    key: 'assaysOrdered',
    transform: (value): string => (
      (value as IBiomaterialRow['assaysOrdered'] ?? [])
        .map((assay) => lbAssays[assay] ?? assay)
        .join(';')
    ),
  },
  downstreamProcess: {
    label: 'Downstream Process',
    selected: true,
    key: 'downstreamProcess',
  },
  dateSentForSequencing: {
    label: 'Date sent for sequencing',
    selected: true,
    key: 'dateSentForSequencing',
    transform: (value): string => (
      value ? dayjs(value as string).format('DD/MM/YYYY') : ''
    ),
  },
};
